import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export const APP_AUTHENTICATION_SERVICE_TOKEN = new InjectionToken<AuthenticationService>('AuthenticationService');

export interface AuthenticationService {
  login?(): void;
  logout(): void;
  initialize(): void;
  isUserLoggedIn(): Observable<boolean>;
}
